import { useEffect, useState } from "react";
import styles from "../alerts.module.css";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-smart-toaster";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

// Values match Alerts::getStatusAttribute() on the server
const STATUS_OPTIONS = [
    { value: 1, label: "Active" },
    { value: 2, label: "Upcoming" },
    { value: 0, label: "Expired" },
];

const AlertFilter = ({ filterData, setFilterData }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList((response.data?.data || []).map(item => ({ value: item?.id, label: item?.name })));
            }).catch((error) => {
                console.error('[CommunityBoard] Failed to load property list for filter', error);
                toast.error(error?.response?.data?.message || 'Unable to load properties. Please try again.');
                setPropertyList([]);
            });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>Filters <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span></p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Select Property"
                        options={propertyList}
                        value={filterData?.property}
                        onChange={(value) => setFilterData(prev => ({ ...prev, property: value }))}
                    />
                </div>

                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Select Status"
                        options={STATUS_OPTIONS}
                        value={filterData?.status}
                        onChange={(value) => setFilterData(prev => ({ ...prev, status: value }))}
                    />
                </div>
            </div>
            <button className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}><Filter /></button>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("communityboard:create") > -1 && <Link to={"/communication/community-boards/add"} className={`${styles.AddNoteBu}`}><Plus /> <span>Alert</span></Link>}
        </div>
    </div>)
}

export default AlertFilter;